import React from 'react';
import '../project-management.scss';

/**
 * Reusable Status Indicator Component
 * Displays a colored dot with status text
 * 
 * @param {string} status - The status value (e.g., 'Active', 'Inactive', 'On-going', etc.)
 * @param {string} customClass - Optional custom CSS class
 */
const StatusIndicator = ({ status, customClass = '' }) => {
    // Normalize status for consistent display
    const normalizedStatus = status ? status.toString().toLowerCase() : 'unknown';
    
    // Determine status class based on the status value
    let statusClass = normalizedStatus;
    let displayText = status || 'Unknown';
    
    // Map common status values to their display format
    switch (normalizedStatus) {
        case 'active':
            statusClass = 'active';
            displayText = 'Active';
            break;
        case 'inactive':
            statusClass = 'inactive';
            displayText = 'Inactive';
            break;
        case 'on-going':
        case 'ongoing':
            statusClass = 'on-going';
            displayText = 'On-going';
            break;
        case 'in-planning':
        case 'planning':
            statusClass = 'in-planning';
            displayText = 'In Planning';
            break;
        case 'in-progress':
        case 'progress':
            statusClass = 'in-progress';
            displayText = 'In Progress';
            break;
        case 'completed':
        case 'complete':
            statusClass = 'completed';
            displayText = 'Completed';
            break;
        case 'on-hold':
        case 'hold':
            statusClass = 'on-hold';
            displayText = 'On Hold';
            break;
        default:
            statusClass = 'unknown';
            displayText = status || 'Unknown';
    }
    
    // Add inline styles as fallback to ensure visibility
    const dotStyle = {
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        display: 'inline-block',
        backgroundColor: statusClass === 'active' ? '#52c41a' : 
                        statusClass === 'inactive' ? '#ff4d4f' : 
                        statusClass === 'on-going' ? '#52c41a' :
                        statusClass === 'completed' ? '#52c41a' :
                        statusClass === 'in-progress' ? '#faad14' :
                        statusClass === 'in-planning' ? '#faad14' :
                        statusClass === 'on-hold' ? '#ff4d4f' : '#999'
    };

    return (
        <div className={`status-indicator-wrapper ${customClass}`} style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', whiteSpace: 'nowrap' }}>
            <span className={`status-dot ${statusClass}`} style={dotStyle} />
            <span className="status-text" style={{ fontSize: '12px', color: '#595959', whiteSpace: 'nowrap' }}>{displayText}</span>
        </div>
    );
};

export default StatusIndicator;